import InventoryPage from '@components/containers/inventory';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const Inventory: FC = () => {
    return (
        <AppLayout>
            <InventoryPage />
        </AppLayout>
    );
};

export default Inventory;
